import {ContactGroupType, Nullable} from "../../definitions/types";

/**
 * @class
 * @description Represents a contact group model for a contact group
 */
export class ContactGroupModel {
    private readonly _contactGroup: Nullable<ContactGroupType>;

    /**
     * @constructor
     * @description Creates a new instance of the model
     * @param contactGroup {Nullable<ContactGroupType>}
     */
    constructor(public readonly contactGroup: Nullable<ContactGroupType>) {
        this._contactGroup = contactGroup;
    }

    /**
     * @method phone
     * @description Returns the contact group phone number
     * @returns {string | undefined}
     * @example
     * 1-800-555-5555
     */
    public get phone(): string | undefined {
        return this._contactGroup?.phoneNumber;
    }

    /**
     * @method email
     * @description Returns the contact group email address, if not available returns undefined
     * @returns {string | undefined}
     */
    public get email(): string | undefined {
        return this._contactGroup?.email;
    }
}